export class DateFormat {

    /**
     * Дата в формате dd.mm.yyyy
     */
    public static formatDateRus(date: Date): string {
        let dd = date.getDate();
        // @ts-ignore: Unreachable code error
        if (dd < 10) dd = '0' + dd;

        let mm = date.getMonth() + 1;
        // @ts-ignore: Unreachable code error
        if (mm < 10) mm = '0' + mm;

        let yyyy = date.getFullYear();

        return dd + '.' + mm + '.' + yyyy;
    }
}
